// extracted by mini-css-extract-plugin
module.exports = {"video-container":"_1n_5u","videoContainer":"_1n_5u","video-poster":"_3UHRA","videoPoster":"_3UHRA","video-poster-img":"_1ytkV","videoPosterImg":"_1ytkV","video":"_1BP2G"};